import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('assetsGridRow');

    return {
        BATTERY: t('battery'),
        DRONE: t('drone')
    };
};

export default useTranslation;
